import io from 'socket.io-client';
import { shuffle } from 'lodash';
import { EventBus } from '../utilities/event.bus';
import socketQuery from '../utilities/socketQuery';
import { env } from '../utilities/environment';
import axios from 'axios';

const gcmApi = {
  staging: [
    'https://gcm-1.staging.de.nsoftcdn.com:8443',
    'https://gcm-2.staging.de.nsoftcdn.com:8443',
  ],

  production: [
    'https://gcm-1.de.nsoftcdn.com:8443',
    'https://gcm-2.de.nsoftcdn.com:8443',
    'https://gcm-3.de.nsoftcdn.com:8443',
  ]
};

class Socket {
    /**
     * @constructor
     */
    constructor(config) {
      let query = socketQuery['get' + sevenConfig.data.dp + 'Query']();

      this.connectGcm(query, config);
    }

    connectGcm(query, config) {
      const api = shuffle(gcmApi[env()])[0] + '/get-lb';

      axios.get(api).then((response) => {
        this.socket = io(response.data.url, {
          query,
          transports: ['websocket'],
        });

        this.cpvUuid = config.data.product.cpvUuid;
        this.subscribe();
      });

    }

    /**
     * Subscribe to channel
     */
    subscribe() {
        this.socket.on('connect', () => {
            this.socket.emit('subscribe', {
                channel: this.cpvUuid,
                subChannels: {
                    language:sevenConfig.data.company.language || sevenConfig.data.company.locale,
                    deliveryPlatform: sevenConfig.data.dp,
                    deviceUuid: sevenConfig.data.device.deviceUuid || sevenConfig.data.device.uuid // TODO : Add unique prop
                },
            });
        });

        this.socket.on(this.cpvUuid, event => {
            // emit game event
            EventBus.$emit('Keno.GameEvent',event);
        });
    }

    /**
     * Get socket connection
     * @returns {*}
     */

    getConnection(){
        return this.socket;
    }

    /**
     * Disconnect
     */

    disconnect(){
        this.socket.emit('unsubscribe', this.cpvUuid);
    }

    /**
     * Send event
     * @param {String} message
     * @param {Object} data
     */

    send(message,data){
        this.socket.emit(message, data)
    }

}

export default Socket;



// WEBPACK FOOTER //
// socket.js